module.exports = __webpack_public_path__ + "img/rumble-in-the-knox.618c868d.png";